import axios from '../utils/axios';

const setAuthToken = token => {
  if (token) {
    axios.defaults.headers.common['x-auth-token'] = token;
  } else {
    delete axios.defaults.headers.common['x-auth-token'];
  }
};

export default setAuthToken;



// WEBPACK FOOTER //
// ./src/utils/setAuthToken.js